import { API_URL } from "../../../../../constants";
import * as httpNetworking from "../../../../../httpNetworking";

const GET_TELEPORT_AVAILABLE_URL = API_URL + "/saas/multi-tenancy/deployment/teleport/available";
const GET_TELEPORT_AVAILABLE_API_VERSION = 0;

type TTeleportAvailable = {
    available: boolean;
    reason?: string;
};

export async function getTeleportAvailable(params: { deploymentType: "production" | "development" }) {
    const options: httpNetworking.GETRequestConfig = {
        timeout: 10000,
        params
    };

    const result = await httpNetworking.simpleGETRequest(
        GET_TELEPORT_AVAILABLE_URL,
        options,
        GET_TELEPORT_AVAILABLE_API_VERSION
    );
    return result.data as TTeleportAvailable;
}
